import type { ButtonHTMLAttributes, ReactNode } from "react";
import "./app-button.scss";
import Loader from "@/components/common/loader/loader";

type AppButtonProps = {
    id?: string;
    className?: string;
    onClick?: ButtonHTMLAttributes<HTMLButtonElement>["onClick"];
    children?: ReactNode;
    variant?: "solid" | "bordered";
    theme?: "gold" | "purple";
    type?: ButtonHTMLAttributes<HTMLButtonElement>["type"];
    isDisabled?: boolean;
    showLoader?: boolean;
    testId?: string;
};

const AppButton = ({
    id = "",
    className = "",
    testId = "",
    onClick = () => {},
    children = null,
    variant = "solid", // solid or bordered
    theme = "gold", // purple or gold
    type = "button",
    isDisabled = false,
    showLoader = false,
}: AppButtonProps) => {
    return (
        <button
            id={id}
            data-testid={testId}
            disabled={isDisabled}
            className={`app-button ${className} ${theme}-${variant} ${isDisabled ? "disabled" : ""}`}
            onClick={onClick}
            type={type}
        >
            {showLoader ? isDisabled ? <Loader isInline size={18.67} loading={isDisabled} /> : children : children}
        </button>
    );
};

export default AppButton;
